// TODO: replace with dynamic imports when webpack supports importing external scripts
//  with transpiling of the import statement itself:
//  https://github.com/webpack/webpack/issues/10446
//  https://github.com/webpack/webpack/issues/8341
export async function importExternalScript(src: string): Promise<HTMLScriptElement> {
	return new Promise((resolve, reject) => {
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const existingScript = document.querySelector<HTMLScriptElement>(`script[src='${src}']`);

		if (existingScript) {
			resolve(existingScript);
			return;
		}

		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		const script = document.createElement('script');
		script.src = src;
		script.onload = () => resolve(script);
		script.onerror = reject;
		// eslint-disable-next-line check-react-ssr-usage/guard-browser-globals
		document.body.appendChild(script);
	});
}
